import Ionicons from "@react-native-vector-icons/ionicons";
import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons";

type IoniconName = keyof typeof Ionicons.glyphMap;
type MaterialIconName = keyof typeof MaterialCommunityIcons.glyphMap;

export type ServiceIcon =
  | { family: "ionicons"; name: IoniconName }
  | { family: "material"; name: MaterialIconName };

export type ServiceTypeOption = {
  value: string;
  label: string;
  shortLabel?: string;
  description?: string;
  icon: ServiceIcon;
};

export const CORE_SERVICES: ServiceTypeOption[] = [
  {
    value: "breakdown_recovery",
    label: "Breakdown Recovery",
    description: "Quick and safe recovery for your vehicle.",
    icon: { family: "material", name: "tow-truck" },
  },
  {
    value: "accident_recovery",
    label: "Accident Recovery",
    description: "Professional recovery after an accident.",
    icon: { family: "material", name: "car-emergency" },
  },
  {
    value: "vehicle_transportation",
    label: "Vehicle Transportation",
    shortLabel: "Vehicle Transportation",
    description: "Move any vehicle to any location.",
    icon: { family: "material", name: "truck-delivery" },
  },
];

export const ADDITIONAL_SERVICES: ServiceTypeOption[] = [
  {
    value: "jump_start",
    label: "Jump Start",
    description: "Get back on the road with a battery jump start.",
    icon: { family: "ionicons", name: "flash" },
  },
  {
    value: "pull_out",
    label: "Pull Out",
    description: "Assistance to pull out stuck vehicles.",
    icon: { family: "material", name: "car-lifted-pickup" },
  },
];

export const OTHER_SERVICES: ServiceTypeOption[] = [
  {
    value: "auto_locksmith",
    label: "Mobile Auto Locksmith",
    shortLabel: "Auto Locksmith",
    description: "Fast and reliable vehicle locksmith service.",
    icon: { family: "ionicons", name: "key" },
  },
  {
    value: "mobile_mechanics",
    label: "Mobile Mechanics",
    shortLabel: "Mobile Mechanic",
    description: "On-site mechanical support for minor repairs.",
    icon: { family: "ionicons", name: "construct" },
  },
  {
    value: "mobile_tyre_fitting",
    label: "Mobile Tyre Fitting",
    shortLabel: "Tyre Fitting",
    description: "Tyre replacement and fitting where you are.",
    icon: { family: "material", name: "tire" },
  },
  {
    value: "mobile_valet",
    label: "Mobile Valet",
    shortLabel: "Mobile Valet",
    description: "Professional cleaning at your location.",
    icon: { family: "ionicons", name: "sparkles" },
  },
  {
    value: "mobile_battery_fitting",
    label: "Mobile Battery Fitting",
    shortLabel: "Battery Fitting",
    description: "Battery testing and replacement on-site.",
    icon: { family: "ionicons", name: "battery-charging" },
  },
  {
    value: "vehicle_diagnostics",
    label: "Mobile Vehicle Inspection / Diagnostics",
    shortLabel: "Vehicle Inspection",
    description: "On-site vehicle inspection and diagnostics.",
    icon: { family: "ionicons", name: "clipboard" },
  },
  {
    value: "vehicle_storage",
    label: "Mobile Vehicle Storage",
    shortLabel: "Vehicle Storage",
    description: "Secure storage for your vehicle.",
    icon: { family: "ionicons", name: "archive" },
  },
  {
    value: "out_of_fuel",
    label: "Mobile Emergency Fuel Delivery",
    shortLabel: "Out of Fuel",
    description: "Fuel delivered when you run out.",
    icon: { family: "ionicons", name: "water" },
  },
  {
    value: "misfuel",
    label: "Mobile Wrong Fuel / Misfuel",
    shortLabel: "Misfuel",
    description: "Help when the wrong fuel was added.",
    icon: { family: "ionicons", name: "warning" },
  },
];

export const SERVICE_SECTIONS = [
  { title: "Core Services", services: CORE_SERVICES, columns: 3 as const },
  {
    title: "Additional Services",
    services: ADDITIONAL_SERVICES,
    columns: 2 as const,
  },
  { title: "Others", services: OTHER_SERVICES, columns: 3 as const },
];

export const ALL_SERVICES = [
  ...CORE_SERVICES,
  ...ADDITIONAL_SERVICES,
  ...OTHER_SERVICES,
];
